import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollPageToTop } from './utils';

const useScrollToTop = (): void => {
	const { pathname } = useLocation();

	useEffect(() => {
		scrollPageToTop();
	}, [pathname]);
};

export { useScrollToTop };
